const Category = {

    // FIELDS
    "category": "Category",
    "name": "Name",
    "description": "Description",
    "depreciation": "Depreciation",
    "status": "Status",
    "search": "Search",
    
    // PAGE HEADER
    "list_title": "Category",
    "filter_title": "Category Filter",
    
    // TABLE HEADER
    "table_name": "Name",
    "table_description": "Description",
    "table_depreciation": "Depreciation",
    
    // ERROR
    "error_name": "Enter Category Name",
    "error_description": "Enter Description",
    "error_depreciation": "Enter Depreciation",
    "error_status": "Select Status",

}

export default Category;

